import type { DatasetBase } from '@core/reports-types';

export const filterDatasetForPieChart = (dataset: DatasetBase): DatasetBase =>
  dataset.filterDataset(row => {
    if (row.length !== 2) {
      return true;
    }
    return row[1] !== 0;
  });
